import axios from "../api";
/** The Gallery Planner: the cheapest plan reaching `targetTokens`, else the most Gallery Tokens, within the limits. Free. */
export const buildGalleryPlan = async (input) => {
    const res = await axios.post("/gallery/plan", input);
    return res.data;
};
export const getGalleryPlanLimits = async () => {
    const res = await axios.get("/gallery/plan/limits");
    return res.data;
};
//# sourceMappingURL=galleryPlan.js.map